import { Box, IconButton, Tooltip } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { borderRadius } from "@mui/system";

// const listItemBox = { padding: "10px 1rem", backgroundColor: "#1a2035" };
const listItemTitleStyle = { textAlign: "center" };
const listItemStyle = { display: "flex", gap: "0.5rem", alignItems: "center" };

function TrafficListItem({ title, values, description }) {
  return (
    <Box sx={{
      backgroundColor: "#1a2035",
      borderRadius: "8px",
      padding: "0.5rem",
    }}>
      <MDBox sx={{ ...listItemTitleStyle, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <MDTypography variant="h6">
          {title}
        </MDTypography>

        {description && (
          <Tooltip
            title={<span dangerouslySetInnerHTML={{ __html: description }} />}
            placement="top"
            arrow
            componentsProps={{
              tooltip: {
                sx: {
                  backgroundColor: "#1a2035", // 🎯 your custom background
                  color: "#fff",              // optional: text color
                  fontSize: "0.875rem",       // optional: tooltip font size
                  // borderRadius: "0.5rem",     // optional: rounded corners
                  maxWidth: 250,              // optional: width cap
                },
              },
              arrow: {
                sx: {
                  color: "#1a2035", // matches tooltip background
                },
              },
            }}
          >
            <IconButton size="small" sx={{ color: "#fff" }}>
              <InfoIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        )}
      </MDBox>
      {/* <MDTypography variant="h6" sx={listItemTitleStyle}>
        {title}
      </MDTypography>

      {description && (
  <Tooltip
    title={<span dangerouslySetInnerHTML={{ __html: description }} />}
    placement="top"
    arrow
  >
    <IconButton sx={{ display: "block", margin: "0 auto", color: "white" }}>
      <InfoIcon />
    </IconButton>
  </Tooltip>
)} */}


      {values.map((item, idx) => (
        <MDBox key={idx} sx={listItemStyle}>
          {/* Label */}
          <MDTypography variant="body2">{item.label}:</MDTypography>
          {/* Value */}
          <MDTypography
            variant="body2"
            color={
              item.status === "pass"
                ? "success"
                : item.status === "notPass"
                  ? "error"
                  : "white"
            }
          >
            {item.value}
          </MDTypography>
        </MDBox>
      ))}
    </Box>
  );
}

export default TrafficListItem;
